/*
 * Adds a hidden `_preorder` line item property to add-to-cart submissions.
 *
 * Why a capture-phase listener on document:
 * the two add-to-cart handlers in this theme (assets/product-form.js, which
 * builds a FormData, and the compiled bundle in assets/main.build.js, which
 * serializes the form) both bind to the form itself and therefore run in the
 * bubble phase. Capture always runs first, so the input is in place before
 * either of them reads the form. That avoids depending on variant-change
 * event timing, which main.build.js does not expose.
 *
 * Why the input is a direct child of the form:
 * main.build.js rewrites the innerHTML of [data-submit-button] on every variant
 * change, so anything placed inside that button is transient.
 *
 * This is additive. The pre-existing, translation-named `properties[Pre Order]`
 * input rendered by snippets/product-form.liquid is left alone.
 */
(function () {
  'use strict';

  var PROPERTY_NAME = 'properties[_preorder]';
  var FORM_SELECTOR = '[data-product-form], form[action*="/cart/add"]';

  /*
   * Read the product JSON the PDP embeds inside its form and look up the
   * variant currently selected, so switching variants is reflected.
   * Returns null when this form carries no product JSON.
   */
  function isPreOrderFromProductJson(form) {
    var jsonEl = form.querySelector('[data-product-json]');

    if (!jsonEl) return null;

    var product;

    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }

    if (!product || !Array.isArray(product.variants)) return null;

    var idInput = form.querySelector('[name="id"]');
    var selectedId = idInput ? String(idInput.value) : '';

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];

      if (variant && String(variant.id) === selectedId) {
        return variant.is_pre_order === true;
      }
    }

    return null;
  }

  /*
   * Forms outside the PDP render a single variant and carry the state as a
   * Liquid-rendered data attribute.
   */
  function isPreOrderFromDataset(form) {
    return form.getAttribute('data-pre-order') === 'true';
  }

  function isPreOrder(form) {
    var fromJson = isPreOrderFromProductJson(form);

    return fromJson === null ? isPreOrderFromDataset(form) : fromJson;
  }

  function setProperty(form, preOrder) {
    var input = form.querySelector('input[name="' + PROPERTY_NAME + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROPERTY_NAME;
      form.appendChild(input);
    } else if (input.parentNode !== form) {
      /*
       * Re-parent if something moved it (or re-rendered around it) so it can't
       * end up inside a container whose innerHTML gets replaced.
       */
      form.appendChild(input);
    }

    /*
     * Shopify drops line item properties with a blank value, so non-pre-order
     * items end up with no `_preorder` key at all rather than "false".
     */
    input.value = preOrder ? 'true' : '';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches(FORM_SELECTOR)) return;

      setProperty(form, isPreOrder(form));
    },
    true
  );
})();
